import React, { PureComponent } from "react";
import { Link } from "react-router-dom";

import ROUTE_CONSTANTS from "../../routes/ROUTE_CONSTANTS";

import thinkAboutNothinAlbumCoverImage from "./norton-think-about-nothing/norton-think-about-nothing-album-cover.jpg";
import iWillTellYouAlbumCoverImage from "./i-will-tell-you/i-will-tell-you-album-cover.jpg";
import christmasSongsOnBassGuitarAlbumCoverImage from "./christmas-songs-on-bass-guitar/christmas-songs-on-bass-guitar-album-cover.jpg";

class MusicPage extends PureComponent {
  render() {
    return (
      <div>
        <h1>Music</h1>

        <div
          style={{
            margin: 5
          }}
        >
          <hr />

          <div>
            <Link to={"https://studioxx.studio"}>
              <h2>
                Studio and record label
              </h2>
            </Link>

            <p>
              Visit these sites for more music.
              <ul>
                <li>
                  <a href="https://studioxx.studio" target="_blank" rel="noopener noreferrer">Studio XX - https://studioxx.studio</a>
                </li>
                <li>
                  <a href="https://xxrecords.net" target="_blank" rel="noopener noreferrer">XX Records - https://xxrecords.net</a>
                </li>
              </ul>
            </p>

          </div>

          <hr />

          <div>
            <Link to={ROUTE_CONSTANTS.MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR}>
              <h2>Christmas Songs On Bass Guitar - album by Mark Allan</h2>
            </Link>

            <p>All bass guitar. All Christmas songs.</p>
            <p>
              Recorded in Saint Paul, Minnesota in July, 2018.
              <br />
              Released September 13, 2018.
            </p>

            <Link to={ROUTE_CONSTANTS.MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR}>
              <img
                alt="Christmas Songs On Bass Guitar - album by Mark Allan - 2018"
                src={christmasSongsOnBassGuitarAlbumCoverImage}
                style={{
                  width: "256",
                  height: "auto",
                  maxWidth: "256"
                }}
              />
            </Link>
          </div>

          <hr />

          <div>
            <Link to={ROUTE_CONSTANTS.MUSIC_NORTON}>
              <h2>
                Think About Nothing - album by the band <i>norton</i>
              </h2>
            </Link>

            <p>
              The album Think About Nothing was recorded in Marshall, Minnesota
              in 2001.
            </p>

            <Link to={ROUTE_CONSTANTS.MUSIC_NORTON}>
              <img
                alt="Think About Nothing - album by norton - 2001"
                src={thinkAboutNothinAlbumCoverImage}
                style={{
                  width: "256",
                  height: "auto",
                  maxWidth: "256"
                }}
              />
            </Link>
          </div>

          <hr />

          <div>
            <Link to={ROUTE_CONSTANTS.MUSIC_I_WILL_TELL_YOU}>
              <h2>I Will Tell You - single by Scott Jyrkas</h2>
            </Link>

            <p>Recorded in Marshall, Minnesota in 1999.</p>

            <Link to={ROUTE_CONSTANTS.MUSIC_I_WILL_TELL_YOU}>
              <img
                alt="I Will Tell You - 1999"
                src={iWillTellYouAlbumCoverImage}
                style={{
                  width: "256",
                  height: "auto",
                  maxWidth: "256"
                }}
              />
            </Link>
          </div>
          <hr />
        </div>
      </div>
    );
  }
}

export default MusicPage;



// WEBPACK FOOTER //
// ./src/routes/music/MusicPage.js